import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import client from '../api/client';
import { EXPENSE_CATEGORIES, COST_CENTERS } from '@shared/constants';
import { useAuth } from './AuthContext';

const OptionsContext = createContext(null);

export function OptionsProvider({ children }) {
  const { user } = useAuth();
  const [categories, setCategories]     = useState(EXPENSE_CATEGORIES);
  const [costCenters, setCostCenters]   = useState(COST_CENTERS);
  const [supervisors, setSupervisors]   = useState([]);
  const [glCodes, setGlCodes]           = useState([]);
  const [projects, setProjects]         = useState([]);
  const [loaded, setLoaded]             = useState(false);

  const refresh = useCallback(() => {
    if (!localStorage.getItem('token')) {
      setLoaded(true);
      return Promise.resolve();
    }
    return Promise.all([
      client.get('/api/categories').then(r => r.data.map(c => c.name)),
      client.get('/api/cost-centers').then(r => r.data.map(c => c.name)),
      client.get('/api/users/supervisors').then(r => r.data).catch(() => []),
      client.get('/api/gl-codes').then(r => r.data).catch(() => []),
      client.get('/api/projects').then(r => r.data).catch(() => []),
    ])
      .then(([cats, ccs, sups, gls, projs]) => {
        setCategories(cats);
        setCostCenters(ccs);
        setSupervisors(sups);
        setGlCodes(gls);
        setProjects(projs);
      })
      .catch(err => {
        console.error('Failed to load options, using defaults:', err);
      })
      .finally(() => setLoaded(true));
  }, []);

  // Fetch options when user logs in
  useEffect(() => { refresh(); }, [user, refresh]);

  return (
    <OptionsContext.Provider value={{ categories, costCenters, supervisors, glCodes, projects, loaded, refresh }}>
      {children}
    </OptionsContext.Provider>
  );
}

export function useOptions() {
  return useContext(OptionsContext);
}
